import { BaseService } from '../../infra/base.service'
import type { Note } from './note'
import type { NotesRepository } from './notes.repository'

export class NotesService extends BaseService<Note> {
    constructor(private personRep: NotesRepository) {
        super(personRep)
    }
}
